var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-row',[_c('v-col',[(_vm.renderEditor)?_c('template-editor',{attrs:{"document-template":_vm.documentTemplate},on:{"submitted":_vm.handleUpdate}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }